import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BooleanConvertionService {
  constructor(private translateService: TranslateService) {
  }

  toAdverb = (value: boolean | string): Observable<boolean | string> => {
    switch (value) {
      case '(Select All)':
        return this.translateService.stream('LABELS.SELECT_ALL');
      case 'true':
        return this.translateService.stream('LABELS.YES');
      case 'false':
        return this.translateService.stream('LABELS.NO');
      case true:
        return this.translateService.stream('LABELS.YES');
      case false:
        return this.translateService.stream('LABELS.NO');
      default :
        return of(value);
    }
  };

  toSimplified = (value: boolean | string): Observable<boolean | string> => {
    switch (value) {
      case 'false':
        return this.translateService.stream('LABELS.DPIA');
      case 'true':
        return this.translateService.stream('LABELS.DPIA_SIMPLIFIED');
      case false:
        return this.translateService.stream('LABELS.DPIA');
      case true:
        return this.translateService.stream('LABELS.DPIA_SIMPLIFIED');
      default :
        return of(value);
    }
  };
}
